import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M2.19,16.29a1,1,0,0,0,.91,0,1,1,0,0,0,.51-.76,1.1,1.1,0,0,0-.54-1,1.85,1.85,0,0,1-.43-.32A2.39,2.39,0,0,1,2,12.37a2.58,2.58,0,0,1,1-2,2.61,2.61,0,0,1,1.64-.58,3.27,3.27,0,0,1,.53.05,1,1,0,0,0,1.2-1c.08-5.74,8.3-7.37,10.82-2.05a1,1,0,0,0,1,.57,3.69,3.69,0,0,1,3,1.37A3.8,3.8,0,0,1,22,11.5,3.42,3.42,0,0,1,20.79,14a1,1,0,0,0-.33.9,1,1,0,0,0,1.59.63A5.38,5.38,0,0,0,24,11.32a5.76,5.76,0,0,0-5.22-5.89.28.28,0,0,1-.19-.12A7.69,7.69,0,0,0,4.49,7.6a.24.24,0,0,1-.22.2A4.63,4.63,0,0,0,.62,10.05,4.42,4.42,0,0,0,0,12.49a4.28,4.28,0,0,0,1.24,3.09A3.93,3.93,0,0,0,2.19,16.29Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M16.74,22.09a1.24,1.24,0,0,0,.32-1.45l-1.23-2.81a.26.26,0,0,1,.07-.29l2.21-2a1.28,1.28,0,0,0,.3-1.38,1.23,1.23,0,0,0-1.17-.76h-2.5a.25.25,0,0,1-.23-.15l-1.34-3.12,0,0a1.29,1.29,0,0,0-2.31,0L9.49,13.28a.25.25,0,0,1-.23.15H6.76a1.24,1.24,0,0,0-1.17.76,1.27,1.27,0,0,0,.32,1.39l2.2,2a.26.26,0,0,1,.06.29L7,20.64a1.24,1.24,0,0,0,.31,1.45,1.31,1.31,0,0,0,.87.34,1.39,1.39,0,0,0,.64-.17l3.11-1.75a.21.21,0,0,1,.24,0l3.12,1.75A1.27,1.27,0,0,0,16.74,22.09Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }